<div class="skeleton-table">
    @for (row of rowsArray(); track $index) {
        <div class="skeleton-row">
            @for (col of columnsArray(); track $index) {
                <div class="skeleton-cell"></div>
            }
        </div>
    }
</div>